<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BpEol0/tc-custom/9781504065290.jpg?1705539641621" alt="This image is the cover for the book Tragedies Volume One"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tragedies Volume One
      </h1>
      <p class="bookDescription body article font2">
        <p><b>These timeless plays by the great Bard of Elizabethan drama explore the hubris of four powerful men who ultimately bring about their own undoing.</b></p><p><i>Richard III</i>: Through coldblooded guile, hunchbacked royal Richard III assumes the throne of England and will stop at nothing to maintain his rule. But he will pay a price for his machinations in this historical play set in the era of the Wars of the Roses.</p><p><i>Coriolanus</i>: The common people of the Roman Republic are rebelling against the elite, but war hero Coriolanus has no patience for those he considers beneath him. When this contempt leads to his exile, his thirst for revenge threatens the very state he once served.</p><p><i>King Lear</i>: An aged king attempts to shake off his responsibilities while retaining his stature. Rewarding the flattery of his two elder daughters even as he banishes his youngest for speaking the truth, Lear is led into exile and madness as his country descends into civil war.</p><i>Julius Caesar</i>: Roman general<b></b>Julius Caesar is basking in the glow of military triumph—but his friend Brutus has fallen in with a band of conspirators who argue the general’s ambitions may soon give way to tyranny. Agreeing to join in Caesar’s assassination, Brutus’s betrayal unleashes tragic consequences.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William Shakespeare
      </h2>
      
      <p class="authorDescription body article">William Shakespeare was an English poet, playwright, and actor. He is widely regarded as the greatest dramatist in the English language. Shakespeare is often called England&rsquo;s national poet and the &ldquo;Bard of Avon.&rdquo;<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?14e3e49c